import { Component } from '@angular/core';

@Component({
  selector: 'app-modling-machine-enhancement',
  templateUrl: './modling-machine-enhancement.component.html',
  styleUrls: ['./modling-machine-enhancement.component.scss']
})
export class ModlingMachineEnhancementComponent {
  conveyersystem:any[] = [
    {
      title: 'Control retrofit for Injection Moulding machines',
      img: 'assets/images/capability/white/moulding_machine_enhancement_1.JPG',
    },
    {
      title: 'Control retrofit for Blow Moulding machines',
      img: 'assets/images/capability/white/moulding_machine_enhancement_2.JPG',
    },
    {
      title: 'Energy Saving​',
      img: 'assets/images/capability/white/moulding_machine_enhancement_3.JPG',
    },
    {
      title: 'Longer Machine Life',
      img: 'assets/images/capability/white/moulding_machine_enhancement_4.JPG',
    },
    {
      title: 'Energy efficient servo power pack upgrades for hydraulic Injection, & Blow Moulding machines',
      img: 'assets/images/capability/white/moulding_machine_enhancement_5.JPG',
    },
    {
      title: 'Faster Response​',
      img: 'assets/images/capability/white/moulding_machine_enhancement_6.JPG',
    },
    {
      title: 'Faster ROI​',
      img: 'assets/images/capability/white/moulding_machine_enhancement_7.JPG',
    }
  ]
}
